import { cn } from "lib/utlis";

export default function AppPlateFormLogos({
  showAppPlatformLogo = true,
  className,
}) {
  return (
    <div
      className={cn(
        "flex items-center gap-2",
        className,
        showAppPlatformLogo && "flex",
        !showAppPlatformLogo && "opacity-0"
      )}
    >
      <a href="/">
        <img alt="App store" src="images/play-store-logo.svg" />
      </a>
      <a href="/">
        <img alt="Google store" src="images/apple-store-logo.svg" />
      </a>
    </div>
  );
}
